/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum DockerWorkerType {
    FULL = 'FULL'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const DockerWorkerTypeValidatorShape = [
    'FULL'
];
export const DockerWorkerTypeValidator = yup.mixed().oneOf(DockerWorkerTypeValidatorShape);
export const DockerWorkerTypeStringifyShapeProperties = {};
export const DockerWorkerTypeStringifyShape: StringSchema = {
    title: 'DockerWorkerType Stringifier',
    type: 'string'
};
export const DockerWorkerTypeStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerWorkerTypeStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function DockerWorkerTypeFromJSON(json: any): DockerWorkerType {
    return DockerWorkerTypeFromJSONTyped(json, false);
}
export function DockerWorkerTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerWorkerType {
    return json as DockerWorkerType;
}
export function DockerWorkerTypeToJSON(value?: DockerWorkerType | null): any {
    return value as any;
}
